import React from 'react';
import { AddOnsActionContextProvider } from '../../../add-on-marketplace/add-ons-action-context';

import { AddOnsCard } from './add-ons-card';

export const AddOnsCardWrapper = () => {
  return (
    <AddOnsActionContextProvider>
      <AddOnsCard />
    </AddOnsActionContextProvider>
  );
};
